import { Box } from '@palmetto/palmetto-components';

import DirectPayVendorLabel from './DirectPayVendorLabel';
import EventBy from './EventBy';

const DirectPayOptOut = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> opted out of Direct Pay
        <DirectPayVendorLabel
          alias={event.data?.directPayMaterialVendorAlias}
          subCompanyId={event.data?.subCompanyId}
        />
      </Box>
    </Box>
  );
};

export default DirectPayOptOut;
